import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { PlayCircle } from "lucide-react";
import { toast } from "sonner";

export const DemoCTA = ({ variant = "primary", className = "", label = "Try live demo", testId = "demo-cta" }) => {
  const { startDemo } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await startDemo();
      toast.success("Welcome to the demo sandbox");
      nav("/app/dashboard");
    } catch (err) {
      toast.error("Could not start demo — try again in a moment");
      setBusy(false);
    }
  };

  const base =
    "group inline-flex items-center gap-2 px-5 py-3 text-sm tracking-tight transition-all duration-300 disabled:opacity-60";
  const styles =
    variant === "primary"
      ? "bg-artha-amber text-artha-ink hover:bg-artha-cream"
      : variant === "dark"
        ? "bg-artha-ink text-artha-cream hover:bg-artha-amber hover:text-artha-ink"
        : "border border-border-subtle hover:border-artha-amber hover:text-artha-amber";

  return (
    <button onClick={run} disabled={busy} data-testid={testId}
      className={`${base} ${styles} ${className}`}>
      <PlayCircle size={16} className="group-hover:rotate-12 transition-transform" strokeWidth={1.5} />
      {busy ? "Spinning up sandbox…" : label}
    </button>
  );
};
